<template>
    <div>
        <div class="container">
            <div>
                <b-alert v-model="showError" dismissible variant="danger">{{ error }} | Patient not found? <strong> <a
                            @click="registerPatient">Register a patient</a></strong></b-alert>
            </div>
            <div class="row align-items-center inner-banner">
                <!-- searChbar -->
                <div class="search-box-one aos">
                    <form @submit.prevent="submitForm">
                        <div class="search-input search-map-line">
                            <i class="feather-phone bficon"></i>
                            <div class="form-group mb-0 d-flex align-items-center">
        <!-- Country Code Dropdown -->
          <select v-model="patient.countryCode" class="country-code-select">
        <option v-for="country in allowedCountries" :value="country.dialCode" :key="country.Code">
          ({{ country.dialCode }}) {{ country.code }}
        </option>
      </select>
                                <input v-model="patient.contactNumber" type="text" class="form-control"
                                    placeholder="Search by Contact number"
                                    :class="{ 'is-invalid': phoneTouched && !validatePhoneNumber() }"
                                    @blur="phoneTouched = true" maxlength="12" style="padding-left: 0.5rem;" />
                            </div>
                        </div>
                        <div class="search-input search-map-line">
                            <i class="feather-mail"></i>
                            <div class="form-group mb-0">
                                <input v-model="patient.email" type="text" class="form-control"
                                    placeholder="Search patient by Email"
                                    :class="{ 'is-invalid': emailTouched && !validateEmail() }"
                                    @blur="emailTouched = true" maxlength="45" />
                            </div>
                        </div>

                        <div class="search-input search-map-line">
                            <i class="feather-user"></i>
                            <div class="form-group mb-0">
                                <input v-model="patient.name" type="text" class="form-control"
                                    placeholder="Search patient by Name"
                                    :class="{ 'is-invalid': firstnameTouched && !validatefirstname() }"
                                    @blur="firstnameTouched = true" maxlength="45" />
                            </div>
                        </div>
                        <div class="form-search-btnx col-12 text-center">
                            <b-button class="btn" type="submit">Search</b-button>
                        </div>
                    </form>

                </div>
            </div>
            <!-- registrationform -->
            <div v-if="showRegisterForm">
                <registerby-doc :doctorImage="doctorImage"></registerby-doc>
            </div>
            <div>
                <!-- searChresults -->
                <div class="col-md-16 col-lg-17 col-xl-11 mx-auto" style="margin-top: 30px;">
                    <div class="align-container" v-if="searchResults.length > 0 && searchPerformed === true">
                        <div class="left-align">
                            <i class="fa fa-long-arrow-left" aria-hidden="true" @click="scrollTableLeft"></i>
                        </div>
                        <div class="right-align">
                            <i class="fa fa-long-arrow-right" aria-hidden="true" @click="scrollTableRight"></i>
                        </div>
                    </div>
                    <div class="tab-pane show active" id="today-appointments">

                        <div class="card card-table mb-0">
                            <div class="card-body">
                                <div class="table-responsive" ref="tableContainer">
                                    <table class="table table-hover table-center mb-0">
                                        <tbody v-if="searchResults.length > 0 && searchPerformed === true">
                                            <tr v-for="patient in searchResults" :key="patient.patientid">
                                                <td>
                                                    <h2 class="table-avatar">
                                                        <router-link :to="'patient-profile/' + patient.patientid"
                                                            class="avatar avatar-sm me-2">
                                                            <img class="avatar-img rounded-circle" :src="getPatientImage(appointment)
                                                                " alt="User Image" />
                                                        </router-link>
                                                        <router-link :to="'patient-profile/' + patient.patientid">
                                                            {{ patient.firstname }} {{ patient.lastname }}
                                                            <span>{{ patient.patientid }}</span>
                                                        </router-link>
                                                    </h2>
                                                </td>
                                                <td>
                             <h2 class="table-avatar">
                              
                              <div
                                @click="bookAppointment(patient.patientid)"
                                style="cursor: pointer;"
                              >
                                {{ patient.contactnumbers }}
                                <span>{{ patient.email }}</span>
                              </div>
                            </h2>
                          
                          </td>
                                                <td class="text-end">
                                                    <div class="table-action">
                                                        <div class="clinic-booking book-appoint">
                                                            <div class="appointment-action">
                                                                <a href="javascript:void(0)"
                                                                    class="btn btn-sm bg-info-light"
                                                                    @click="bookAppointment(patient.patientid)"
                                                                    data-bs-target="#appt_details"
                                                                    style="padding: 6px 5px; font-size: 9px; width: 130px;">
                                                                    <i class="fas fa-calendar-check"></i> Book
                                                                    Appointment
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <Paginator
                                    :pagination="pagination"
                                    :loading="loading"
                                    @page-changed="searchPatients"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="!showRegisterForm" class="text-center dont-have" style="margin-top: 20px; margin-bottom: 20px;">
        Patient not found?
        <strong><a @click="registerPatient" style="color: #3b5998;">Register the patient</a></strong>
    </div>
</template>
<script>
import RegisterByDoc from '@/views/frontend/pages/doctors/appointmentbydoctor/registerby-doc.vue';
import axios from 'axios';
import Paginator from "@/components/paginator.vue";

export default {
    components: {
        'registerby-doc': RegisterByDoc,
         Paginator
    },
    props: {
        doctorImage: {
            type: String,
        },
    },
    data() {
        return {
            doctorDetails: [],
             allowedCountries: [
          { name: 'India', code: 'IN', dialCode: '+91' },
          { name: 'United States', code: 'US', dialCode: '+1' },
          { name: 'United Kingdom', code: 'GB', dialCode: '+44' },
          { name: 'Canada', code: 'CA', dialCode: '+1' },
          { name: 'Australia', code: 'AU', dialCode: '+61' },
          { name: 'United Arab Emirates', code: 'AE', dialCode: '+971' },
          { name: 'Bahrain', code: 'BH', dialCode: '+973' },
          { name: 'Kuwait', code: 'KW', dialCode: '+965' },
          { name: 'Oman', code: 'OM', dialCode: '+968' },
          { name: 'Qatar', code: 'QA', dialCode: '+974' },
          { name: 'Saudi Arabia', code: 'SA', dialCode: '+966' },
          { name: 'Singapore', code: 'SG', dialCode: '+65' },
          { name: 'Malaysia', code: 'MY', dialCode: '+60' },
          { name: 'New Zealand', code: 'NZ', dialCode: '+64' },
        ],
            patient: {
                countryCode:'+91',
                contactNumber: '',
                email: '',
                name: '',
            },
            doctorid: null,
            patientid: null,
            searchResults: [],
            showError: false,
            error: null,
            firstnameTouched: false,
            lastnameTouched: false,
            emailTouched: false,
            phoneTouched: false,
            showRegisterForm: false,
            loading: false,
            pagination: {
                total: 0,
                page: 1,
                per_page: 10,
                total_pages: 0,
                has_next: false,
                has_prev: false
            },
            searchPerformed: null,
        }
    },
    methods: {
        scrollTableRight() {
            const tableContainer = this.$refs.tableContainer;
            tableContainer.scrollBy({
                left: 200,
                behavior: 'smooth'
            });
        },

        scrollTableLeft() {
            const tableContainer = this.$refs.tableContainer;
            tableContainer.scrollBy({
                left: -200, 
                behavior: 'smooth'
            });
        },

        registerPatient() {
            this.showRegisterForm = true;
            this.searchPerformed = false;
        },
        async searchPatients(page = 1) {
            try {
                const contactNumber= (this.patient.contactNumber)?`${this.patient.countryCode}${this.patient.contactNumber}`:"";
                const response = await axios.get('patients', {
                    params: {
                        contactnumbers: contactNumber,
                        patientname: this.patient.name,
                        email: this.patient.email,
                        page: page,
                        per_page: this.pagination.per_page
                    }
                });
                if (response.data.patients && Array.isArray(response.data.patients)) {
                    this.searchResults = response.data.patients;
                    this.patientid = response.data.patients[0].patientid;
                    this.pagination = response.data.pagination;
                } else {
                    this.showError = true;
                    this.error = response.data;
                }
            } catch (error) {
                this.showError = true;
                this.error = error.message;
            }
        },
        async fetchDoctorDetails() {
            const doctorId = sessionStorage.getItem("userdbid");
            this.doctorid = doctorId;
            try {
                let docDetails = sessionStorage.getItem(`doctorDetails${doctorId}`);
                if (!docDetails) {
                    const response = await axios.get(`/doctors/${doctorId}`);
                    docDetails = response.data;
                    sessionStorage.setItem(
                        `doctorDetails${this.doctorId}`,
                        JSON.stringify(docDetails)
                    );
                } else {
                    docDetails = JSON.parse(docDetails);
                }
                this.doctorDetails = docDetails;
                // console.log("Doctor Details:", this.doctorDetails);
            } catch (error) {
                console.error("Error fetching doctor details:", error);
            }
        },
        async bookAppointment(patientid) {
            try {

                this.$store.dispatch("updateAppointmentDraft", {
                    doctorid: this.doctorid,
                    patientid: patientid,
                    doctorImage: this.doctorImage
                });
                this.$router.push({
                    path: "/booking/" + this.doctorid,
                    query: { from: 'doctorDashboard' }
                });
            } catch (error) {
                console.error("Error booking appointment:", error);
            }
        },
        validatefirstname() {
            const firstnameRegex = /^([A-Za-z\s]*)$/
            return firstnameRegex.test(this.patient.name);
        },
        validateEmail() {
            const emailRegex = /^$|^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.[a-zA-Z][a-zA-Z0-9-]{0,45}[a-zA-Z])$/;
            return emailRegex.test(this.patient.email);
        },
        validatePhoneNumber() {
            const phoneNumberRegex = /^(\s*|\d{10,12})$/;
            return phoneNumberRegex.test(this.patient.contactNumber);
        },
        submitForm() {
            this.showError = false;
            let invalids = [];
            if (!this.patient.contactNumber && !this.patient.email && !this.patient.name) {
                this.error = "Please enter contact number or email, or name";
                this.showError = true;
                window.scrollTo({ top: 0, behavior: "smooth" });
                return;
            }
            if (this.firstnameTouched && !this.validatefirstname()) {
                invalids.push("valid first name");
            }
            if (this.emailTouched && !this.validateEmail()) {
                invalids.push(" valid email");
            }
            if (this.phoneTouched && !this.validatePhoneNumber()) {
                invalids.push("valid Phone number");
            }
            if (invalids.length > 0) {
                this.error = "Please enter " + invalids.join(", ");
                this.showError = true;
                window.scrollTo({ top: 0, behavior: "smooth" });
                return;
            }
            this.searchPatients();
            this.searchPerformed = true;
            this.showRegisterForm = false
        },
        getPatientImage(appointment) {
            return (
                // patient.patientimage || require("@/assets/img/patients/patient.jpg")
                require("@/assets/img/patients/patient.jpg")
            );
        }
    },
    mounted() {
        this.fetchDoctorDetails();
    }
};
</script>
<style scoped>
.country-code-select {
  border: 1px solid #ced4da; 
  border-radius: 4px;
  
  font-size: 14px; 
  color: #495057; 
  height: 32px;
  width: 62px;
  margin-left: 20px;
}
.right-align {
    text-align: right;
    font-size: 24px;
    margin-right: 10px;
    cursor: pointer;
}

.text-end {
    text-align: right;
}

.left-align {
    text-align: left;
    font-size: 24px;
    margin-left: 10px;
    cursor: pointer;
}

.align-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>